import React from "react";
import Navbar from "../pagesections/Navbar";
import "./Termhero.css";
import Herocontenta from "../aboutuscomp/Herocontenta";
import TermHeroH from "../aboutuscomp/TermHeroH.jsx";
import TermHeroHero from "../aboutuscomp/TermHeroH.jsx";
import FaqqHero from "../aboutuscomp/FaqqHero.jsx";

function FaqHero() {
  return (
    <>
    <Navbar/>
    <div className="hero-sec-small">
        <Navbar/>
        <FaqqHero/>
    </div>
    </>
  );
}

export default FaqHero;
